import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Card, CardBody } from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import IntlMessage from '../../../../helpers/intlMessage';

function Grid ({ pagina, totalItens, totalItensPage, setPagina, onclickLine }) {
  const lista = useSelector(state => state.solicitacao.listaSolicitacoes);

  return (
    <Card>
      <CardBody>
        <Container fluid>
          <DataTable
            onContextMenu={e => onclickLine(e)}
            value={lista}
            responsive={true}
            selectionMode='single'
            style={{ height: '100%' }}
            scrollHeight='50vh'
            columnResizeMode='expand'
            scrollable={true}
            scrollWidth='100%'
            resizableColumns={lista.length >= 1}
            reorderableColumns={lista.length >= 1}
            first={(pagina - 1) * totalItensPage}
            rows={totalItensPage}
            lazy={true}
            paginator={lista.length > 0}
            emptyMessage={<IntlMessage id="general.requestsPanel.noResultsFound" />}
            alwaysShowPaginator={false}
            autoLayout={true}
            totalRecords={totalItens}
            onPage={event => setPagina(event.page + 1)}
            footer={<Footer totalItens={totalItens} />}
          >
            <Column 
            field='nrExame' 
            style={{ width: '100px' }} 
            header={<IntlMessage id="general.requestsPanel.exam" />}
             />
            <Column 
            field='tipo' 
            style={{ width: '120px' }} 
            header={<IntlMessage id="general.requestsPanel.type" />}
            />
            <Column
              field='statusFormated'
              style={{ width: '120px' }}
              header={<IntlMessage id="general.requestsPanel.status" />}
            />
            <Column 
            field='bloco' 
            style={{ width: '200px' }} 
            header={<IntlMessage id="general.requestsPanel.block" />} 
            />
            <Column 
            field='frasco' 
            style={{ width: '200px' }} 
            header={<IntlMessage id="general.requestsPanel.bottle" />}
             />
            <Column
              field='usuarioSolicitante'
              style={{ width: '120px' }}
              header={<IntlMessage id="general.requestsPanel.requester" />}
            />
            <Column
              field='usuarioExecutante'
              style={{ width: '120px' }}
              header={<IntlMessage id="general.requestsPanel.performer" />}
            />
            <Column
              field='dataCadastro'
              style={{ width: '150px' }}
              header={<IntlMessage id="general.requestsPanel.registrationDate" />}
            />
            <Column
              field='dataAlteracao'
              style={{ width: '150px' }}
              header={<IntlMessage id="general.requestsPanel.dateOfChange" />}
            />
          </DataTable>
        </Container>
      </CardBody>
    </Card>
  );
}

const Footer = ({ totalItens }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItens: 'center'
    }}
  >
    <span
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItens: 'center'
      }}
    >
      <i
        className='mv-basico-stacktrace'
        style={{ fontSize: '20px', height: '18px' }}
      />{' '}
      <span style={{ marginTop: '2px' }}>
      {<IntlMessage id="general.requestsPanel.totalRequests" />}: {totalItens}
      </span>
    </span>
  </div>
);
export default Grid;



// WEBPACK FOOTER //
// ./src/pages/solicitacao/Solicitacoes/Grid/index.js